/** Theme-aware CSS custom properties (compiled from src/styles/_palette.scss). */
export const cv = {
  bg: 'var(--noah-bg)',
  surface: 'var(--noah-surface)',
  surfaceHover: 'var(--noah-surface-hover)',
  surfaceMuted: 'var(--noah-surface-muted)',
  surfaceSubtle: 'var(--noah-surface-subtle)',
  surfaceStrong: 'var(--noah-surface-strong)',
  surfaceRaised: 'var(--noah-surface-raised)',
  surfaceActive: 'var(--noah-surface-active)',
  skeletonBase: 'var(--noah-skeleton-base)',
  skeletonHighlight: 'var(--noah-skeleton-highlight)',
  border: 'var(--noah-border)',
  borderStrong: 'var(--noah-border-strong)',
  borderFocus: 'var(--noah-border-focus)',
  borderInputHover: 'var(--noah-border-input-hover)',
  dividerSubtle: 'var(--noah-divider-subtle)',
  divider: 'var(--noah-divider)',
  textPrimary: 'var(--noah-text-primary)',
  textSecondary: 'var(--noah-text-secondary)',
  textSubheader: 'var(--noah-text-subheader)',
  textMuted: 'var(--noah-text-muted)',
  textInverse: 'var(--noah-text-inverse)',
  textOnCta: 'var(--noah-text-on-cta)',
  brandBlue: 'var(--noah-brand-blue)',
  brandBlueLight: 'var(--noah-brand-blue-light)',
  brandBlueDark: 'var(--noah-brand-blue-dark)',
  brandPurple: 'var(--noah-brand-purple)',
  brandPurpleLight: 'var(--noah-brand-purple-light)',
  brandPurpleDark: 'var(--noah-brand-purple-dark)',
  brandOrchid: 'var(--noah-brand-orchid)',
  brandTeal: 'var(--noah-brand-teal)',
  brandGradient: 'var(--noah-brand-gradient)',
  brandGradientHover: 'var(--noah-brand-gradient-hover)',
  brandShadow: 'var(--noah-brand-shadow)',
  brandShadowSoft: 'var(--noah-brand-shadow-soft)',
  brandShadowStrong: 'var(--noah-brand-shadow-strong)',
  blueSelectionSurface: 'var(--noah-blue-selection-surface)',
  indigo: 'var(--noah-indigo)',
  indigoLight: 'var(--noah-indigo-light)',
  indigoSurface: 'var(--noah-indigo-surface)',
  violetAccent: 'var(--noah-violet-accent)',
  purpleLight: 'var(--noah-purple-light)',
  purpleLighter: 'var(--noah-purple-lighter)',
  purpleSelection: 'var(--noah-purple-selection)',
  purpleSelectionSoft: 'var(--noah-purple-selection-soft)',
  purpleSelectionStrong: 'var(--noah-purple-selection-strong)',
  purpleSelectionHover: 'var(--noah-purple-selection-hover)',
  purpleSelectionBg: 'var(--noah-purple-selection-bg)',
  purpleSelectionBorder: 'var(--noah-purple-selection-border)',
  purpleSelectionRing: 'var(--noah-purple-selection-ring)',
  purpleFocusRing: 'var(--noah-purple-focus-ring)',
  purpleChipBorder: 'var(--noah-purple-chip-border)',
  purpleSurface: 'var(--noah-purple-surface)',
  purpleSurfaceHover: 'var(--noah-purple-surface-hover)',
  destructive: 'var(--noah-destructive)',
  destructiveHover: 'var(--noah-destructive-hover)',
  destructiveBorder: 'var(--noah-destructive-border)',
  destructiveSurface: 'var(--noah-destructive-surface)',
  destructiveBorderSoft: 'var(--noah-destructive-border-soft)',
  success: 'var(--noah-success)',
  successDark: 'var(--noah-success-dark)',
  successText: 'var(--noah-success-text)',
  successSurface: 'var(--noah-success-surface)',
  warning: 'var(--noah-warning)',
  warningSurface: 'var(--noah-warning-surface)',
  errorText: 'var(--noah-error-text)',
  errorSurface: 'var(--noah-error-surface)',
  favorite: 'var(--noah-favorite)',
  drawerSurface: 'var(--noah-drawer-surface)',
  dialogSurface: 'var(--noah-dialog-surface)',
  dialogSurfaceStrong: 'var(--noah-dialog-surface-strong)',
  headerBackground: 'var(--noah-header-background)',
  popoverSurface: 'var(--noah-popover-surface)',
  popoverSurfaceDeep: 'var(--noah-popover-surface-deep)',
  toolbarSurface: 'var(--noah-toolbar-surface)',
  subtoolbarSurface: 'var(--noah-subtoolbar-surface)',
  glassBackground: 'var(--noah-glass-background)',
  islandSurface: 'var(--noah-island-surface)',
  footerTint: 'var(--noah-footer-tint)',
  sidebarSurface: 'var(--noah-sidebar-surface)',
  panelTint: 'var(--noah-panel-tint)',
  elevatedSurface: 'var(--noah-elevated-surface)',
  videoStage: 'var(--noah-video-stage)',
  backdropScrim: 'var(--noah-backdrop-scrim)',
  backdropScrimStrong: 'var(--noah-backdrop-scrim-strong)',
  overlayScrim: 'var(--noah-overlay-scrim)',
  sidebarScrim: 'var(--noah-sidebar-scrim)',
  cardShadow: 'var(--noah-card-shadow)',
  dialogShadow: 'var(--noah-dialog-shadow)',
  popoverShadow: 'var(--noah-popover-shadow)',
  dropdownShadow: 'var(--noah-dropdown-shadow)',
  tooltipShadow: 'var(--noah-tooltip-shadow)',
  tooltipSurface: 'var(--noah-tooltip-surface)',
  tooltipText: 'var(--noah-tooltip-text)',
  tooltipTextMuted: 'var(--noah-tooltip-text-muted)',
  insetHighlight: 'var(--noah-inset-highlight)',
  insetHighlightSoft: 'var(--noah-inset-highlight-soft)',
  gridDot: 'var(--noah-grid-dot)',
  avatar1: 'var(--noah-avatar-1)',
  avatar2: 'var(--noah-avatar-2)',
  avatar3: 'var(--noah-avatar-3)',
  avatar4: 'var(--noah-avatar-4)',
  avatar5: 'var(--noah-avatar-5)',
  avatar6: 'var(--noah-avatar-6)',
  avatarSurplusBg: 'var(--noah-avatar-surplus-bg)',
  linkChipText: 'var(--noah-link-chip-text)',
  linkChipBg: 'var(--noah-link-chip-bg)',
  linkChipBgHover: 'var(--noah-link-chip-bg-hover)',
  waveFill1: 'var(--noah-wave-fill-1)',
  waveFill2: 'var(--noah-wave-fill-2)',
  waveFill3: 'var(--noah-wave-fill-3)',
  waveFill4: 'var(--noah-wave-fill-4)',
  purpleFocusRingTight: 'var(--noah-purple-focus-ring-tight)',
  purpleBorderSoft: 'var(--noah-purple-border-soft)',
  blueGlow18: 'var(--noah-blue-glow-18)',
  blueGlow24: 'var(--noah-blue-glow-24)',
  blueGlow30: 'var(--noah-blue-glow-30)',
  blueGlow35: 'var(--noah-blue-glow-35)',
  purpleGlow24: 'var(--noah-purple-glow-24)',
  purpleGlow40: 'var(--noah-purple-glow-40)',
  islandShadow: 'var(--noah-island-shadow)',
  toolbarShadow: 'var(--noah-toolbar-shadow)',
  emojiPickerSurface: 'var(--noah-emoji-picker-surface)',
  emojiPickerBorder: 'var(--noah-emoji-picker-border)',
  emojiPickerInputBorder: 'var(--noah-emoji-picker-input-border)',
  emojiPickerText: 'var(--noah-emoji-picker-text)',
  emojiPickerPlaceholder: 'var(--noah-emoji-picker-placeholder)',
  strokeFocusRing: 'var(--noah-stroke-focus-ring)',
  stampGradient: 'var(--noah-stamp-gradient)',
  billingHeroGradient: 'var(--noah-billing-hero-gradient)',
  shapeDefault: 'var(--noah-shape-default)',
  slateAvatar: 'var(--noah-slate-avatar)',
  gray900Ui: 'var(--noah-gray-900-ui)',
  checkerDark: 'var(--noah-checker-dark)',
  checkerLight: 'var(--noah-checker-light)',
  annotationGuide: 'var(--noah-annotation-guide)',
  whiteBorderSoft: 'var(--noah-white-border-soft)',
  whiteBorderDashed: 'var(--noah-white-border-dashed)',
  whiteSurfaceStrong: 'var(--noah-white-surface-strong)',
  whiteSurfaceMedium: 'var(--noah-white-surface-medium)',
  inkOverlay04: 'var(--noah-ink-overlay-04)',
  inkOverlay06: 'var(--noah-ink-overlay-06)',
  inkOverlay08: 'var(--noah-ink-overlay-08)',
  inkOverlay10: 'var(--noah-ink-overlay-10)',
  inkOverlay12: 'var(--noah-ink-overlay-12)',
  inkOverlay14: 'var(--noah-ink-overlay-14)',
  inkOverlay16: 'var(--noah-ink-overlay-16)',
  inkOverlay18: 'var(--noah-ink-overlay-18)',
  inkOverlay20: 'var(--noah-ink-overlay-20)',
  inkOverlay25: 'var(--noah-ink-overlay-25)',
  inkOverlay28: 'var(--noah-ink-overlay-28)',
  inkOverlay35: 'var(--noah-ink-overlay-35)',
  inkOverlay38: 'var(--noah-ink-overlay-38)',
  inkOverlay80: 'var(--noah-ink-overlay-80)',
  inkOverlay88: 'var(--noah-ink-overlay-88)',
  inkScrim72: 'var(--noah-ink-scrim-72)',
  inkScrim88: 'var(--noah-ink-scrim-88)',
  inkDark: 'var(--noah-ink-dark)',
  gray200: 'var(--noah-gray-200)',
  gray600: 'var(--noah-gray-600)',
  destructiveStrong: 'var(--noah-destructive-strong)',
  destructiveDeep: 'var(--noah-destructive-deep)',
  blueSelectionHover: 'var(--noah-blue-selection-hover)',
  blueDragSurface: 'var(--noah-blue-drag-surface)',
  blueAccentSurface: 'var(--noah-blue-accent-surface)',
  bluePurpleGradient: 'var(--noah-blue-purple-gradient)',
  purpleSelectionMedium: 'var(--noah-purple-selection-medium)',
  purpleGlowSoft: 'var(--noah-purple-glow-24)',
  purpleFocusBorder: 'var(--noah-purple-focus-border)',
  purpleLightStrong: 'var(--noah-purple-light-strong)',
  purpleLightDashed: 'var(--noah-purple-light-dashed)',
  purpleSurfaceActive: 'var(--noah-purple-surface-active)',
  greenBright: 'var(--noah-green-bright)',
  greenBrightSurface: 'var(--noah-green-bright-surface)',
  yellowAccentSurface: 'var(--noah-yellow-accent-surface)',
  indigoAccentSurface: 'var(--noah-indigo-accent-surface)',
  redGlowSoft: 'var(--noah-red-glow-soft)',
  playheadRing: 'var(--noah-playhead-ring)',
  focusRingBlue: 'var(--noah-focus-ring-blue)',
  focusRingPurple4: 'var(--noah-focus-ring-purple-4)',
  focusRingPurple2: 'var(--noah-focus-ring-purple-2)',
  loginBrandShadow: 'var(--noah-login-brand-shadow)',
  loginBrandShadowHover: 'var(--noah-login-brand-shadow-hover)',
  commentCardShadow: 'var(--noah-comment-card-shadow)',
  commentHoverShadow: 'var(--noah-comment-hover-shadow)',
  markerShadow: 'var(--noah-marker-shadow)',
  stampMarkerShadow: 'var(--noah-stamp-marker-shadow)',
  avatarPinShadow: 'var(--noah-avatar-pin-shadow)',
  selectedToolbarShadow: 'var(--noah-selected-toolbar-shadow)',
  drawerScrim: 'var(--noah-drawer-scrim)',
  timelineScrim: 'var(--noah-timeline-scrim)',
  previewPlayShadow: 'var(--noah-preview-play-shadow)',
  previewCardShadow: 'var(--noah-preview-card-shadow)',
  uploadPreviewGradient: 'var(--noah-upload-preview-gradient)',
  rainbowRed: 'var(--noah-rainbow-red)',
  rainbowYellow: 'var(--noah-rainbow-yellow)',
  rainbowGreen: 'var(--noah-rainbow-green)',
  rainbowBlue: 'var(--noah-rainbow-blue)',
  rainbowPurple: 'var(--noah-rainbow-purple)',
  brandGradientHorizontal: 'var(--noah-brand-gradient-horizontal)',
  rainbowConic: 'var(--noah-rainbow-conic)',
  blue200: 'var(--noah-blue-200)',
  pinkAccent: 'var(--noah-pink-accent)',
  slateMuted: 'var(--noah-slate-muted)',
  blueSelectionFaint: 'var(--noah-blue-selection-faint)',
  blueAccentMedium: 'var(--noah-blue-accent-medium)',
  blueGlowStrong: 'var(--noah-blue-glow-strong)',
  blueBorderStrong: 'var(--noah-blue-border-strong)',
  blueBorderSoft: 'var(--noah-blue-border-soft)',
  blueGlow50: 'var(--noah-blue-glow-50)',
  greenAccentMedium: 'var(--noah-green-accent-medium)',
  greenAccentSurface: 'var(--noah-green-accent-surface)',
  purpleAccentSurface: 'var(--noah-purple-accent-surface)',
  blackScrim30: 'var(--noah-black-scrim-30)',
  blackScrim70: 'var(--noah-black-scrim-70)',
  textInverseMuted: 'var(--noah-text-inverse-muted)',
  popoverShadowElevated: 'var(--noah-popover-shadow-elevated)',
  islandShadowStrong: 'var(--noah-island-shadow-strong)',
  cardHoverShadow: 'var(--noah-card-hover-shadow)',
  videoScrimGradient: 'var(--noah-video-scrim-gradient)',
  mediaTypeGradientEnd: 'var(--noah-media-type-gradient-end)',
  notificationGlow: 'var(--noah-notification-glow)',
  shapePickerShadow: 'var(--noah-shape-picker-shadow)',
  textInverseSoft: 'var(--noah-text-inverse-soft)',
  textInverseFaint: 'var(--noah-text-inverse-faint)',
  textInverseDim: 'var(--noah-text-inverse-dim)',
  planBadgeGlow: 'var(--noah-plan-badge-glow)',
  badgeFilledGradient: 'var(--noah-badge-filled-gradient)',
  badgeFilledBorder: 'var(--noah-badge-filled-border)',
  badgeFilledText: 'var(--noah-badge-filled-text)',
  badgeOutlinedBg: 'var(--noah-badge-outlined-bg)',
  badgeOutlinedBorder: 'var(--noah-badge-outlined-border)',
  badgeOutlinedText: 'var(--noah-badge-outlined-text)',
  logoGlow: 'var(--noah-logo-glow)',
  commentPinGlow: 'var(--noah-comment-pin-glow)',
  liquidBlueOrb: 'var(--noah-liquid-blue-orb)',
  liquidPurpleOrb: 'var(--noah-liquid-purple-orb)',
  liquidIndigoOrb: 'var(--noah-liquid-indigo-orb)',
  liquidFloorGlow: 'var(--noah-liquid-floor-glow)',
  stampTextShadow: 'var(--noah-stamp-text-shadow)',
  stampTextStroke: 'var(--noah-stamp-text-stroke)',
  stampSelectedGlow: 'var(--noah-stamp-selected-glow)',
  dragPreviewBorder: 'var(--noah-drag-preview-border)',
  dragPreviewShadow: 'var(--noah-drag-preview-shadow)',
  thumbnailChipBg: 'var(--noah-thumbnail-chip-bg)',
  thumbnailChipBgHover: 'var(--noah-thumbnail-chip-bg-hover)',
  thumbnailChipBorder: 'var(--noah-thumbnail-chip-border)',
  thumbnailChipShadow: 'var(--noah-thumbnail-chip-shadow)',
} as const;

/** User-selectable palette tokens for tags, workspaces, and annotation tools. */
export const palette = {
  black: 'var(--noah-palette-black)',
  gray: 'var(--noah-palette-gray)',
  grayLight: 'var(--noah-palette-gray-light)',
  white: 'var(--noah-palette-white)',
  whiteSoft: 'var(--noah-palette-white-soft)',
  red: 'var(--noah-palette-red)',
  redLight: 'var(--noah-palette-red-light)',
  orange: 'var(--noah-palette-orange)',
  orangeLight: 'var(--noah-palette-orange-light)',
  yellow: 'var(--noah-palette-yellow)',
  yellowLight: 'var(--noah-palette-yellow-light)',
  green: 'var(--noah-palette-green)',
  greenLight: 'var(--noah-palette-green-light)',
  teal: 'var(--noah-palette-teal)',
  tealLight: 'var(--noah-palette-teal-light)',
  blue: 'var(--noah-palette-blue)',
  blueLight: 'var(--noah-palette-blue-light)',
  sky: 'var(--noah-palette-sky)',
  purple: 'var(--noah-palette-purple)',
  purpleLight: 'var(--noah-palette-purple-light)',
  pink: 'var(--noah-palette-pink)',
  pinkLight: 'var(--noah-palette-pink-light)',
  cyan: 'var(--noah-palette-cyan)',
  amber: 'var(--noah-palette-amber)',
} as const;

/** Avatar stack rotation colors. */
export const avatarStackColors = [
  cv.avatar1,
  cv.avatar2,
  cv.avatar3,
  cv.avatar4,
  cv.avatar5,
  cv.avatar6,
] as const;
